import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_rh, registro_no_guardado } from '../../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../../Services/AuthService';
import { JsonMovimientosEmpleado } from '../../../../Helpers/JsonToOneLevel';
import ModalService from '../../../../ModalService/ModalService';
import AlertForm from '../../../../../../../Services/AlertForm';
import FormularioVariables from './FormularioVariables';

const ModalAddMovimientos = ({ openAdd, setOpenAdd, agregar, errorTable, informacionAdicional, idModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }

    const enviarMovimiento = ( movimiento ) => {
        axios.post( `${servicios_grupogack_rh}/movimientos/`, movimiento, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        agregar( JsonMovimientosEmpleado( respuesta.data.dataResponse ));
                        setOpenAdd( false );
                        break;
                    case 400:
                        setError( <AlertForm message={ respuesta.data.msg } /> );
                        break;
                    default:
                        errorTable( registro_no_guardado );
                        break;
                }
            })
            .catch( error => {
                errorTable( registro_no_guardado );
            })
    }

    return (
        <ModalService title="Nuevo Movimiento Variable" parentNode={idModulo} minWidth="40%"
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
                <FormularioVariables
                    error={error}
                    informacion={informacionAdicional}
                    enviarMovimiento={enviarMovimiento}
                />
        </ModalService>
    );
};

export default ModalAddMovimientos;